import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, Typography, Breadcrumbs } from '@material-ui/core';

// CONSTANTS
import { breadcrumbNameMap, ROUTE_ROOT } from '@/constants/routes';
import { LOCATIONS_BREADCRUMBS } from '@/constants/locations';

// UTILITY
import { usePathPattern } from '@/utility/path';

// COMPONENTS
import RouterLink from '@/components/Link';

const LinkRouter = props => <Link {...props} variant="inherit" component={RouterLink} />;

const chevronRight = <i className="icon-chevron-right" />;

const RouterBreadcrumbs = props => {
  const { className, exclude, lastBreadcrumbText } = props;
  const [t] = useTranslation();
  const location = useLocation();
  const path = usePathPattern();
  const isIframe = useSelector(({ app }) => app.isIframe);

  const pathnames = location.pathname.split('/').filter(x => x);
  const pathparams = path
    .split('/')
    .filter(x => x)
    .map(pathPart => pathPart.replace(':', ''));

  const excludeData = exclude.concat('partner');

  if (isIframe) {
    excludeData.push('home');
  }

  return (
    <Breadcrumbs className={className} aria-label="Breadcrumb" separator={chevronRight}>
      {!excludeData.includes('home') && (
        <LinkRouter to={ROUTE_ROOT} location={LOCATIONS_BREADCRUMBS}>
          {t('common.menu.home')}
        </LinkRouter>
      )}
      {pathnames.map((value, index) => {
        if (excludeData.includes(value) || pathparams[index] === 'partner') return null;

        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        let title = t(`breadcrumbs.${pathparams[index]}`, '') || pathparams[index];

        if (breadcrumbNameMap[to]) {
          title = t(breadcrumbNameMap[to]);
        }

        return last ? (
          <Typography key={to} color="inherit" variant="inherit">
            {lastBreadcrumbText || title}
          </Typography>
        ) : (
          <LinkRouter to={to} key={to} location={LOCATIONS_BREADCRUMBS}>
            {title}
          </LinkRouter>
        );
      })}
    </Breadcrumbs>
  );
};

RouterBreadcrumbs.defaultProps = {
  className: '',
  lastBreadcrumbText: '',
  exclude: [],
};

RouterBreadcrumbs.propTypes = {
  className: PropTypes.string,
  exclude: PropTypes.array,
  lastBreadcrumbText: PropTypes.string,
};

export default React.memo(RouterBreadcrumbs);
